export default __webpack_public_path__ + "static/media/PublicBusLogo.9c3eb23a.png";